<template>
  <div class="candidate name signup-prompt">
    <Conversation v-model="conversation" @scroll="$emit('scroll')" @done="$emit('done')" />
  </div>
</template>

<script>
// Components
import Conversation from '@/components/prompts/Conversation'

// Helpers
import { mapGetters } from 'vuex'

export default {
  components: { Conversation },

  created() {
    this.initialize()
  },

  data() {
    return {
      conversation: [],
    }
  },

  methods: {
    initialize() {
      this.conversation = [
        {
          key: 0,
          next: 1,
          text: 'namePrompt01',
          type: 'prompt',
        },
        {
          key: 1,
          next: 2,
          text: 'namePrompt02',
          type: 'prompt',
        },
        {
          key: 2,
          component: { name: 'NameForm', next: 3 },
          type: 'prompt',
          text: 'namePrompt03',
        },
        {
          key: 3,
          next: 4,
          text: 'nameResponse01',
          type: 'response',
        },
        {
          key: 4,
          last: true,
          type: 'prompt',
          text: 'namePrompt04',
        },
      ]
    },
  },
}
</script>
